import { assertKitchenResponse, isLiveTask } from "./kitchenActions";

export const isPendingKitchenJob = (job) =>
  job?.status === "PENDING" && (job.tasks || []).some((task) =>
    isLiveTask(task) && Number(task.quantity) > 0 && task.status !== "IN_PROGRESS");

/** Whole-order decisions only. Never use this for a dish-only selection. */
export async function performPendingKitchenDecision({
  jobIds, status, reason, getFreshJobs, updateJobs, audit, isCurrent = () => true,
}) {
  if (!["IN_PROGRESS", "REJECTED"].includes(status)) {
    throw new Error("Unsupported pending-order decision.");
  }
  const ids = [...new Set((jobIds || []).filter(Boolean).map(String))];
  if (!ids.length) throw new Error("Select a pending order first.");
  if (status === "REJECTED" && (
    typeof reason !== "string" || reason.trim().length < 3 ||
    reason.trim().length > 500 || !/\p{L}/u.test(reason)
  )) {
    throw new Error("A valid rejection reason is required.");
  }
  const jobs = await getFreshJobs();
  if (!isCurrent()) throw new Error("Kitchen location changed. Reopen the action in the current location.");
  // Do not silently apply a bulk action to a different selection after a race.
  if (ids.some((id) => !jobs.some((job) =>
    String(job.jobId) === id && isPendingKitchenJob(job)))) {
    throw new Error("These orders have changed or are no longer pending. Refresh and select them again.");
  }
  assertKitchenResponse(await updateJobs({
    ...audit, jobIds: ids, status,
    ...(status === "REJECTED" ? { reason: reason.trim() } : {}),
  }));
  return { jobIds: ids, status };
}
